// extracted by mini-css-extract-plugin
export default {"textBox":"text-dnd_textBox__x1RN0"};